<!--
 * @Description: 短信管理
 * @Version: 1.0
 * @Autor: zhaoyy
 * @Date: 2022-08-22 09:59:35
 * @LastEditors: zhaoyy
 * @LastEditTime: 2022-09-23 15:11:22
-->
<template>
  <div class="message-management">
    <el-tabs v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="短信账户" name="account">
        <MessageAccount />
      </el-tab-pane>
      <el-tab-pane label="短信模板" name="template">
        <SmsTemplateManage />
      </el-tab-pane>
      <el-tab-pane label="短信账单" name="bill">
        <MessageBill />
      </el-tab-pane>
      <el-tab-pane label="购买记录" name="log">
        <PurchaseHistory />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SmsTemplateManage from '@/views/control/SmsTemplateManage.vue'
import MessageAccount from './MessageAccount.vue'
import MessageBill from './MessageBill.vue'
import PurchaseHistory from './PurchaseHistory.vue'
export default {
  name: "messageManagement",
  components: {
    SmsTemplateManage,
    MessageAccount,
    MessageBill,
    PurchaseHistory
  },
  data() {
    return {
      activeName: 'account'
    }
  },
  methods: {
    tabClick(tab, event) {
      console.log(tab, event);
    }
  }
}
</script>

<style lang="scss" scoped>
.message-management {
  padding: 30px 30px 0 30px;
}
::v-deep .el-tabs__content {
  height: calc(100vh - 200px);
  overflow-y: auto;
}
</style>
